import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { IBreadcrumbProps } from './types';

export const Breadcrumb: FunctionComponent<IBreadcrumbProps> = ({ items, className }) => {
  const visibleItems = items.filter((item) => item.name);

  if (visibleItems.length === 0) {
    return null;
  }

  return (
    <nav className={`page-breadcrumb${className ? ` ${className}` : ''}`} aria-label="Breadcrumb">
      <ol>
        {visibleItems.map((item, index) => {
          const isLast = index === visibleItems.length - 1;

          return (
            <li key={`${item.name}-${index}`}>
              {index > 0 && (
                <span className="page-breadcrumb__sep" aria-hidden="true">
                  {'>'}
                </span>
              )}
              {isLast ? (
                <span className="page-breadcrumb__current" aria-current="page">
                  {item.name}
                </span>
              ) : item.path ? (
                <Link to={item.path} className="page-breadcrumb__link">
                  {item.name}
                </Link>
              ) : (
                <span className="page-breadcrumb__parent">{item.name}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
